/**
* @copyright Copyright (C) 2020 Kokoon - All Rights Reserved
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
*/

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const KnArrowDownIcon = (props) => (
  <SvgIcon {...props}>
    <path fill="#000" fillOpacity=".54" d="M7 10l5 5 5-5H7z" />
  </SvgIcon>
);

export default KnArrowDownIcon;
